var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import "./home.css";
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper";
import "swiper/css";
import Modal from "react-modal";
import goIcon from "../../assets/icons/go-icon.svg";
import { Link } from "react-router-dom";
import { raffleCategories } from "../../store/games.store";
import { HomeNewRaffleWidget, HomeRaffleWidget } from "./raffle.widget";
import { modalServiceSubject } from "../../services/modal.service";
import { categoryEmojiMapping, env } from "../../constants/global.constants";
import { ResetPassword } from "../../shared/auth/resetpassword";
import { isMobile } from "../../App";
import { VerifyEmail } from "../../shared/auth/verify.email";
import { getRaffleCategories } from "../../services/game.service";
import { useForceUpdate } from "../../services/misc.functions";
import { api } from "../../services/http.service";
import { useNavigate } from "react-router";
import DOMPurify from "dompurify";
import { useForm } from "react-hook-form";
import "swiper/css/navigation";
import { auth } from "../../store/auth.store";
import InputMask from "react-input-mask";
import campagin1 from "../../assets/images/esanspopup1.png";
import paths from "../../paths";
export function Home() {
    var forceUpdate = useForceUpdate();
    var navigate = useNavigate();
    var _a = useState(null), homeStats = _a[0], setHomeStats = _a[1];
    var _b = useState(false), showStoryModal = _b[0], setShowStoryModal = _b[1];
    function closeModal() {
        setShowStoryModal(false);
    }
    useEffect(function () {
        getRaffleCategories().then(function (res) {
            api
                .start("post", env.accounting_api + "/misc/api/list-flatpages/", { slug: "anasayfa-stats" }, false)
                .then(function (res) {
                setHomeStats(res.data.content);
            });
        });
    }, []);
    var sanitizedData = function () { return ({
        __html: DOMPurify.sanitize(homeStats),
    }); };
    // story modal kaç sn ekranda kalacak buradan belirleniyor
    useEffect(function () {
        setTimeout(function () {
            setShowStoryModal(false);
        }, 10000);
    }, [showStoryModal]);
    var _c = useForm(), register = _c.register, handleSubmit = _c.handleSubmit, reset = _c.reset, errors = _c.formState.errors;
    var onSubmit = function (payload) {
        if (auth.member && auth.member.id) {
            api
                .start("post", env.accounting_api + "/somos/api/check-coupon/", payload, true)
                .then(function (res) {
                if (res && res.status && res.count > 0) {
                    modalServiceSubject.next({
                        case: res.data[0].status === "Oynandı"
                            ? "info"
                            : res.data[0].status === "Kazandı"
                                ? "success"
                                : "danger",
                        title: res.data[0].status,
                        content: "<p class=\"text-center\">Ad\u0131n\u0131za kay\u0131tl\u0131 ".concat(payload.approve_code, " numaral\u0131 biletiniz, ").concat(res.data[0].draw_is_result
                            ? res.data[0].status + " olarak değerlendirilmiştir."
                            : "henüz sonuçlanmamıştır.", "</p>"),
                        confirm: {
                            cancel: {
                                label: "Kapat",
                                class: "btn btn-info w-100",
                            },
                        },
                    });
                }
                else {
                    modalServiceSubject.next({
                        case: "info",
                        title: "Bilet bulunamadı",
                        content: "<p class=\"text-center\">Ad\u0131n\u0131za kay\u0131tl\u0131 b\u00F6yle bir bilet numaras\u0131 bulunamad\u0131. L\u00FCtfen bilet numaran\u0131z\u0131 kontrol edip tekrar deneyin.</p>",
                        confirm: {
                            cancel: {
                                label: "Kapat",
                                class: "btn btn-info w-100",
                            },
                        },
                    });
                }
                // console.log(res)
            });
        }
        else {
            if (isMobile) {
                navigate(paths.landing.url);
            }
            else {
                modalServiceSubject.next({
                    class: "success",
                    title: "Üye Girişi",
                    content: "<p>Bilet sorgulama i\u00E7in \u00F6nce oturum a\u00E7man\u0131z gerekli. \u00DCye de\u011Filseniz hemen \u00FCye olabilir yada giri\u015F yaparak al\u0131\u015Fveri\u015Finizi tamamlaya bilirsiniz.</p>",
                    confirm: {
                        sure: {
                            label: "Giriş Yap",
                            class: "btn btn-success",
                            action: function () {
                                navigate(paths.login.url);
                            },
                        },
                        cancel: {
                            label: "Üye Ol",
                            class: "btn btn-info",
                            action: function () {
                                navigate(paths.register.url);
                            },
                        },
                    },
                });
            }
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "row" }, { children: _jsxs("div", __assign({ className: "row drawers-slider-container-top" }, { children: [_jsx("h2", __assign({ className: "home-heading d-none d-xl-block d-lg-block" }, { children: "\u00C7ekili\u015Fler" })), _jsx("hr", { className: "d-none d-xl-block d-lg-block" }), !isMobile && (_jsxs("div", __assign({ className: "col-5 ", style: { filter: "drop-shadow(0 0 6px #cfe6e7)" } }, { children: [_jsx("div", __assign({ className: "widget blue mt-3" }, { children: _jsxs("div", __assign({ className: "body" }, { children: [_jsxs("div", __assign({ style: { flex: 1 } }, { children: [_jsx("h2", { children: "Bilet Sorgula" }), _jsx("p", { children: "Bilet numaras\u0131n\u0131 ile durumunu sorgulayabiirsiniz." })] })), _jsxs("form", __assign({ className: "w-100", onSubmit: handleSubmit(onSubmit) }, { children: [_jsxs("div", __assign({ className: "my-2", style: { display: "flex" } }, { children: [_jsx(InputMask, __assign({ mask: "999999", className: "form-control py-2" }, register("approve_code", { required: true }), { placeholder: "Bilet Numaras\u0131" })), _jsx("button", __assign({ className: "btn btn-light mx-1" }, { children: _jsx("img", { src: goIcon }) }))] })), _jsx("div", {})] }))] })) })), _jsx("div", __assign({ className: "widget mt-3" }, { children: _jsx("div", __assign({ className: "body p-1" }, { children: _jsx(HomeNewRaffleWidget, {}) })) }))] }))), _jsxs("div", __assign({ className: "col-12 col-lg-7" }, { children: [isMobile && (_jsxs("div", __assign({ className: "mobile-menu-icon d-flex mt-0" }, { children: [_jsxs(Link, __assign({ to: paths.deposit.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_deposit.png", alt: "" }), "Para Yat\u0131r"] })), _jsxs(Link, __assign({ to: paths.liveStream.url, className: "col" }, { children: [_jsx("img", { src: "/assets/images/home_icon_live_stream.png", alt: "" }), "Canl\u0131 \u0130zle"] }))] }))), _jsx("div", __assign({ className: "pointer " }, { children: _jsx(HomeRaffleWidget, { withCategories: false }) }))] }))] })) })), _jsx("div", __assign({ className: "row" }, { children: raffleCategories.length > 0 && !isMobile && (_jsx(HomeCategoryWidget, {})) })), _jsx(ResetPassword, {}), _jsx(VerifyEmail, {}), _jsx(Modal, __assign({ isOpen: showStoryModal, 
                // className={"default product-detail-modal"}
                className: "default", onRequestClose: closeModal, contentLabel: "", style: {
                    content: {
                        width: "40%",
                    },
                } }, { children: _jsx("img", { className: "img-fluid", src: campagin1, alt: "" }) }))] }));
}
export function HomeCategoryWidget() {
    var _a = useState("populer"), selectedCategory = _a[0], setSelectedCategory = _a[1];
    var navigate = useNavigate();
    // const {boxShadow, onScrollHandler} = useScrollWithShadow();
    // const navigationCatPrevRef = useRef(null);
    // const navigationCatNextRef = useRef(null);
    var width = window.innerWidth;
    var forceUpdate = useForceUpdate();
    // console.log(width);
    var resizeWindow = function () {
        width = window.innerWidth;
        forceUpdate();
    };
    useEffect(function () {
        window.addEventListener("resize", resizeWindow);
        return function () {
            window.removeEventListener("resize", resizeWindow);
        };
    }, []);
    return (_jsx("div", __assign({ className: "drawers-slider-container-bottom" }, { children: _jsxs("div", __assign({ className: "home-raffle-slider-with-category mb-4" }, { children: [_jsx("div", __assign({ className: "widget categories my-3 categories-slider-container" }, { children: _jsxs(Swiper, __assign({ spaceBetween: 0, slidesPerView: width > 1400 ? 5 : width > 1100 ? 4 : 3, navigation: true, modules: [Navigation] }, { children: [_jsx(SwiperSlide, { children: _jsx("div", { children: _jsx("a", __assign({ className: "pointer category-slider-item", onClick: function () {
                                            // navigate(paths.raffleTickets+'?category='+category.id)
                                            navigate(paths.raffleTickets.url);
                                        } }, { children: "T\u00FCm\u00FC" })) }, "all-category") }, "all-category-slide"), raffleCategories.map(function (category, key) {
                                return (_jsx(SwiperSlide, { children: _jsx("div", __assign({ className: selectedCategory === category ||
                                            (key === 0 && selectedCategory === null)
                                            ? "category-slider-item-active"
                                            : "" }, { children: _jsxs("a", __assign({ className: "pointer category-slider-item", onClick: function () {
                                                // navigate(paths.raffleTickets+'?category='+category.id)
                                                setSelectedCategory(category);
                                            } }, { children: [categoryEmojiMapping[category.id], " ", category.name] })) }), "".concat(key, "-category")) }, "".concat(key, "-category-slide")));
                            })] })) })), _jsx("div", __assign({ className: "widget raffles" }, { children: _jsx(HomeRaffleWidget, { selectedCategory: selectedCategory, withCategories: true }) }))] })) })));
}
